import React from 'react';
import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {defineMessages, FormattedMessage, FormattedHTMLMessage} from 'react-intl';

import FormField from './../FormField.jsx';
import FormCountryPhoneField from './../FormCountryPhoneField.jsx';
import FormSelectableField from './../FormSelectableField.jsx';
import FormRadioGroupField from './../FormRadioGroupField.jsx';
import FastRegistrationFormValidation from './FastRegistrationFormValidation';

import * as FastJoinType from 'constants/FastJoinType';
import { isRingo } from '../../../../shared/domainUtils.js';

const messages = defineMessages({
    joinType: {
        id: 'join.fast.type',
        defaultMessage: 'Регистрация по'
    },
    joinTypeSms: {
        id: 'join.fast.type.sms',
        defaultMessage: 'SMS'
    },
    joinTypeEmail: {
        id: 'join.fast.type.email',
        defaultMessage: 'E-mail'
    },
    email: {
        id: 'join.fast.email',
        defaultMessage: 'E-mail'
    },
    phone: {
        id: 'join.fast.phone',
        defaultMessage: 'Номер телефона'
    },
    currency: {
        id: 'join.fast.currency',
        defaultMessage: 'Валюта'
    },
    buttonJoin: {
        id: 'join.fast.button_join',
        defaultMessage: 'Зарегистрироваться'
    },
    tacAgree: {
        id: 'join.fast.tac_agree',
        defaultMessage: "Нажимая кнопку, вы соглашаетесь с <a href={rulesLink} target='_blank'>правилами компании</a>, <a href={privacyLink} target='_blank'>политикой конфиденциальности</a>, и подтверждаете свое совершеннолетие"
    },
    tacAgreeRingo: {
        id: 'join.fast.tac_agree_ringo',
        defaultMessage: "Нажимая кнопку, вы соглашаетесь с <a href={rulesLink} target='_blank'>правилами компании</a>, <a href={privacyLink} target='_blank'>политикой конфиденциальности</a>, и подтверждаете, что Ваш возраст превышает 21 год"
    },
    internalErrorText: {
        id: 'join.errors.internal',
        defaultMessage: 'Ошибка. Попробуйте позже'
    },
    smsExceededErrorText: {
        id: 'join.errors.smsexceeded',
        defaultMessage: 'Мы дважды выслали на Ваш номер сообщение для подтверждения счёта. Пожалуйста, дождитесь СМС, либо укажите e-mail и мы вышлем информацию о подтверждении счёта на него.'
    },
    emailTakenErrorText: {
        id: 'join.errors.email_taken',
        defaultMessage: 'E-mail используется'
    },
    phoneTakenErrorText: {
        id: 'join.errors.phone_taken',
        defaultMessage: 'Телефон используется'
    },
    promoTitle: {
        id: 'promocode.title',
        defaultMessage: 'Промо-код'
    },
    promoPlaceholder: {
        id: 'promocode.enter',
        defaultMessage: 'Введите промо-код'
    },
    '-1':{
      id: "promocode.error.not_found",
      defaultMessage: "Ошибка. Попробуйте позже"
    },
    '-2':{
      id: "promocode.error.not_active",
      defaultMessage: "Промокод уже использован"
    },
    '-3':{
      id: "promocode.error.used",
      defaultMessage: "Промокод не действителен"
    },
    '-4':{
      id: "promocode.error.not_available",
      defaultMessage: "Промокод не действителен"
    },
});

const joinTypes = [
    {id: FastJoinType.SMS, name: messages.joinTypeSms},
    {id: FastJoinType.EMAIL, name: messages.joinTypeEmail}
];

const fields = [
    'promo',
    'type',
    'email',
    'phone',
    'countryId',
    'countryCode',
    'countryNumberLength',
    'accountResourceId',
    'PromocodeText'
];

const jsonSourceToOptions = (jsonSource) => {
    const optionsArr = [];
    for (let itemKey in jsonSource) {
        if (!jsonSource.hasOwnProperty(itemKey)) {
            continue;
        }

        let option;

        if (jsonSource[itemKey].hasOwnProperty('id') && jsonSource[itemKey].hasOwnProperty('defaultMessage')) {
            option = (
                <FormattedMessage key={itemKey} {...jsonSource[itemKey]}>
                    {(msg) => <option key={itemKey} value={itemKey}>{msg}</option>}
                </FormattedMessage>
            );
        } else {
            option = (<option key={itemKey} value={itemKey}>{jsonSource[itemKey]}</option>);
        }

        optionsArr.push(option);
    }

    return optionsArr;
};

const countriesJsonToOptions = (jsonSource) => {
    const elements = [];
    for (let itemKey in jsonSource) {
        if (!jsonSource.hasOwnProperty(itemKey)) {
            continue;
        }

        const country = jsonSource[itemKey];

        elements.push({
            id: itemKey,
            key: itemKey,
            iconClass: country.short,
            name: country.name
        });
    }

    return elements;
};

class FastRegistrationForm extends React.Component {
    static propTypes = {
        fields: React.PropTypes.object.isRequired,
        handleSubmit: React.PropTypes.func.isRequired,
        submitting: React.PropTypes.bool.isRequired,
        languageId: React.PropTypes.number.isRequired,
        joining: React.PropTypes.bool.isRequired,
        joinError: React.PropTypes.any,
        promoCodeError: React.PropTypes.any,
        accountResources: React.PropTypes.object.isRequired,
        countries: React.PropTypes.object.isRequired,
        domain: React.PropTypes.string.isRequired,
        submitAction: React.PropTypes.func.isRequired
    };

    static renderError(error) {
        return (
            <div className="error-message">
                <FormattedMessage {...error}/>
            </div>
        );
    }

    static renderHint(hint) {
        return (
            <div className="hint hint--error">
                <FormattedMessage {...hint}/>
            </div>
        );
    }

    _onSubmit = (values) => {
        if (values.type == FastJoinType.SMS) {
            const phone = /^\d+$/.test(values.phone) === false ?
                undefined :
                values.countryCode.substring(1).concat(values.phone);

            this.props.submitAction({
                Phone: phone,
                CountryId: values.countryId,
                AccountResourceId: values.accountResourceId,
                LanguageId: this.props.languageId,
                Type: values.type,
                Promo: values.promo,
                PromocodeText: values.PromocodeText
            });
        } else if (values.type == FastJoinType.EMAIL) {
            this.props.submitAction({
                Email: values.email,
                AccountResourceId: values.accountResourceId,
                LanguageId: this.props.languageId,
                Type: values.type,
                Promo: values.promo,
                PromocodeText: values.PromocodeText
            });
        }
    }

    render() {
        const {
            fields:
                {type, email, phone, countryId, countryCode, countryNumberLength, accountResourceId, PromocodeText},
            handleSubmit, submitting, joinError, promoCodeError, joining, accountResources, countries, domain, fastJoin
            } = this.props;

        const submitHandler = this._onSubmit;
        const isSameEmail = email.value === (fastJoin && fastJoin.get('Email'))

        const accountResourceOptions = jsonSourceToOptions(accountResources);
        const countriesOptions = countriesJsonToOptions(countries);

        const layerClass = 'login--form__row form__row';

        let btnClass = 'login--form__btn login--form__btn__js form__btn';

        const btnDisabled = (submitting || joining || (joinError === -3 && type.value == FastJoinType.SMS) ||
            (type.value == 1 && phone.error) || (type.value == 2 && email.error));
        if (btnDisabled) {
            btnClass += ' disabled';
        }

        let errMessage = messages.internalErrorText;

        if (joinError === -3) {
            errMessage = messages.smsExceededErrorText
        }

        if(joinError === -5 && promoCodeError) {
            errMessage = messages[promoCodeError]
        }

        const agreeOptions = {rulesLink: '//help.' + domain, privacyLink: '//help.' + domain + '/privacy'};

        if(countryCode.value === "+998") {
            joinTypes[0] = {id: FastJoinType.SMS, name: messages.phone}
        }

        let showGlobalError = joinError
        if(joinError === -2 || joinError === -4) showGlobalError = false

        return (
            <form className="login--form form" onSubmit={handleSubmit(submitHandler)} autoComplete="off">
                {showGlobalError && FastRegistrationForm.renderError(errMessage)}

                <FormRadioGroupField
                    message={messages.joinType}
                    name="joinType"
                    field={type}
                    options={joinTypes}/>
                {type.touched && type.error && FastRegistrationForm.renderHint(type.error)}

                {type.value == FastJoinType.SMS && <FormCountryPhoneField message={messages.phone}
                                                     phone={phone}
                                                     countryId={countryId}
                                                     countries={countries}
                                                     countryOptions={countriesOptions}
                                                     countryCode={countryCode}
                                                     numberLength={countryNumberLength}
                                                     joinError={joinError}
                                                     msg={messages.phoneTakenErrorText}
                                                     required/>}
                {type.value == FastJoinType.EMAIL &&
                    <FormField message={messages.email} type="email" field={email} required joinError={isSameEmail && joinError} msg={messages.emailTakenErrorText} />}

                <FormSelectableField
                    disabled
                    message={messages.currency}
                    field={accountResourceId}
                    options={accountResourceOptions}
                    required/>

                <FormField message={messages.promoTitle} type="PromocodeText" field={PromocodeText} joinError={isSameEmail && joinError} />

                <div className="form__row form__row--terms">
                    <FormattedHTMLMessage {...(isRingo ? messages.tacAgreeRingo : messages.tacAgree)} values={agreeOptions}/>
                </div>

                <div className="modal--content__controls">
                    <div className={layerClass}>
                        <button type="submit"
                                className={btnClass}
                                disabled={btnDisabled}
                                onClick={handleSubmit(submitHandler)}>
                            <FormattedMessage {...messages.buttonJoin}/>
                        </button>
                    </div>
                </div>
            </form>);
    }
}

export default connect()(reduxForm({
    form: 'fast-registration-form',
    fields,
    asyncBlurFields: ['email', 'phone', 'countryId', 'promo', 'PromocodeText'],
    validate: FastRegistrationFormValidation
})(FastRegistrationForm));



// WEBPACK FOOTER //
// ./js/sport-betting/components/registration/fast/FastRegistrationForm.jsx